import { router } from "@inertiajs/react";

type ImpersonationBannerProps = {
  name: string;
  email: string;
};

export default function ImpersonationBanner({ name, email }: ImpersonationBannerProps) {
  function stopImpersonating() {
    router.delete("/impersonate");
  }

  return (
    <div className="border-b border-amber-300 bg-amber-50 px-4 py-3 text-amber-950">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm font-medium">
          Impersonating {name} ({email})
        </p>
        <button type="button" className="btn w-fit text-sm" onClick={stopImpersonating}>
          Stop impersonating
        </button>
      </div>
    </div>
  );
}
